export function LogsIcon({ className }: { className: string }) {
  return (
    <svg
      className={className}
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      fill="currentColor"
    >
      <g>
        <path
          d="M95.2,5H4.8C2.1,5,0,7.1,0,9.8v9.7h100V9.8C100,7.1,97.9,5,95.2,5z M8.8,13.9c-0.1,0.1-0.2,0.2-0.4,0.3
		c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2,0.1-0.3,0.1-0.5,0.2c-0.2,0-0.3,0.1-0.5,0.1c-0.2,0-0.3,0-0.5-0.1c-0.2,0-0.3-0.1-0.5-0.2
		c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1-0.1-0.3-0.2-0.4-0.3c-0.5-0.5-0.7-1.1-0.7-1.8c0-0.7,0.3-1.3,0.7-1.8c0.6-0.6,1.4-0.8,2.3-0.7
		c0.2,0,0.3,0.1,0.5,0.2c0.2,0.1,0.3,0.1,0.4,0.2c0.1,0.1,0.3,0.2,0.4,0.3c0.5,0.5,0.7,1.1,0.7,1.8C9.5,12.8,9.2,13.5,8.8,13.9z
		 M17.5,12.7c0,0.2-0.1,0.3-0.1,0.5c-0.1,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.1-0.2,0.2-0.4,0.3
		c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0.1-0.3,0.1-0.5,0.1c-0.2,0-0.3,0.1-0.5,0.1c-0.7,0-1.3-0.3-1.8-0.7c-0.1-0.1-0.2-0.2-0.3-0.4
		c-0.1-0.1-0.2-0.3-0.2-0.4c-0.1-0.2-0.1-0.3-0.1-0.5s-0.1-0.3-0.1-0.5c0-0.2,0-0.3,0.1-0.5c0-0.2,0.1-0.3,0.1-0.5
		c0.1-0.1,0.1-0.3,0.2-0.4c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.1,0.2-0.2,0.4-0.3c0.1-0.1,0.3-0.2,0.4-0.2c0.1-0.1,0.3-0.1,0.5-0.2
		c0.8-0.2,1.7,0.1,2.3,0.7c0.1,0.1,0.2,0.2,0.3,0.4c0.1,0.1,0.2,0.3,0.2,0.4c0.1,0.2,0.1,0.3,0.1,0.5c0,0.2,0.1,0.3,0.1,0.5
		C17.6,12.4,17.6,12.5,17.5,12.7z M25.6,12.7c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.2,0.3-0.3,0.4
		c-0.1,0.1-0.2,0.2-0.4,0.3c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2,0.1-0.3,0.1-0.5,0.2c-0.2,0-0.3,0.1-0.5,0.1c-0.2,0-0.3,0-0.5-0.1
		c-0.2,0-0.3-0.1-0.5-0.2c-0.2-0.1-0.3-0.1-0.4-0.2c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1-0.1-0.2-0.3-0.2-0.4
		c-0.1-0.2-0.1-0.3-0.2-0.5c0-0.2,0-0.3,0-0.5c0-0.2,0-0.3,0-0.5c0-0.2,0.1-0.3,0.2-0.5c0.1-0.1,0.1-0.3,0.2-0.4
		c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.1,0.2-0.2,0.4-0.3c0.1-0.1,0.3-0.2,0.4-0.2c0.2-0.1,0.3-0.1,0.5-0.2c0.3-0.1,0.7-0.1,1,0
		c0.2,0,0.3,0.1,0.5,0.2c0.1,0.1,0.3,0.1,0.4,0.2c0.1,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.2,0.2,0.3,0.4c0.1,0.1,0.2,0.3,0.2,0.4
		c0.1,0.2,0.1,0.3,0.2,0.5c0,0.2,0,0.3,0,0.5C25.7,12.4,25.7,12.5,25.6,12.7z"
        />
        <path
          d="M0,90.2C0,92.9,2.1,95,4.8,95h90.5c2.6,0,4.8-2.1,4.8-4.8V24.5H0V90.2z M32,78.6h20.4v5H32V78.6z M32,67.9
		h20.4v5H32V67.9z M32,57.2h20.4v5H32V57.2z M32,46.5h20.4v5H32V46.5z M81.3,62.2H57.4v-5h23.9V62.2z M81.3,72.9h-10v-5h10V72.9z
		 M57.4,67.9h8.8v5h-8.8V67.9z M66.2,51.5h-8.8v-5h8.8V51.5z M57.4,78.6h15.7v5H57.4V78.6z M94,83.6H78.1v-5H94V83.6z M94,72.9h-7.7
		v-5H94V72.9z M94,62.2h-7.7v-5H94V62.2z M94,51.5H71.2v-5H94V51.5z M94,40.8h-7.7v-5H94V40.8z M81.3,40.8H57.4v-5h23.9V40.8z
		 M52.4,40.8H32v-5h20.4V40.8z M6.1,35.8H27v5H6.1V35.8z M6.1,46.5H27v5H6.1V46.5z M6.1,57.2H27v5H6.1V57.2z M6.1,67.9H27v5H6.1
		V67.9z M6.1,78.6H27v5H6.1V78.6z"
        />
      </g>
    </svg>
  );
}
